import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import base from '@/_api/base';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '../query-keys';

export function useServicesQuery(festivalId) {
  return useGetQuery(
    () => `/admin/services/${festivalId}`,
    {},
    queryKeys.services(festivalId),
    { enabled: festivalId != null && festivalId !== '' },
  );
}

export function useServiceTypesQuery() {
  return useGetQuery(
    () => '/admin/service-types',
    {},
    queryKeys.serviceTypes(),
    {},
  );
}

export function useSaveServiceMutation(festivalId) {
  const queryClient = useQueryClient();
  return useApiMutation(
    (service) => `/admin/service/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.services(festivalId),
        });
        NotificationManager.success('Service saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Service not saved', 'Error', 3000);
      },
    },
  );
}

export function useRemoveServiceMutation(festivalId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (serviceId) => base.delete(`/admin/service/${serviceId}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.services(festivalId),
      });
      NotificationManager.success('Service removed', '', 3000);
    },
    onError: () => {
      NotificationManager.error('Service could not be removed', '', 3000);
    },
  });
}
